import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseHttpService } from "./base.http.service";
import { TaxRateCategory, TaxRateCategoryToAdd } from "../types/tax-rate-categories";

@Injectable({
  providedIn: "root",
})
export class TaxRateCategoriesService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getTaxRateCategories(): Observable<TaxRateCategory[]> {
    return this.http.get<TaxRateCategory[]>(`${this.apiUrl}/api/TaxRateCategory`);
  }

  createTaxRateCategory(data: TaxRateCategoryToAdd): Observable<void> {
    const apiUrl = `${this.apiUrl}/api/TaxRateCategory`;
    return this.http.post<void>(apiUrl, data);
  }

  updateTaxRateCategory(id: number, data: TaxRateCategoryToAdd): Observable<void> {
    const apiUrl = `${this.apiUrl}/api/TaxRateCategory/${id}`;
    return this.http.put<void>(apiUrl, data);
  }

  deleteTaxRateCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/api/TaxRateCategory/${id}`);
  }
}
